import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/authUtils';

const ApplicationTrackingModal = ({ recruiterId, companyName, onClose, onStatusUpdate }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showDateInput, setShowDateInput] = useState(false);
  const [appliedDate, setAppliedDate] = useState(new Date().toISOString().split('T')[0]);

  const handleYesApplied = () => {
    setShowDateInput(true);
  };

  const handleConfirmApplied = async () => {
    setIsSubmitting(true);
    try {
      const authToken = localStorage.getItem('studentAuthToken');

      await axios.post(
        `${API_URL}/api/student/update-application-status/${recruiterId}`,
        {
          status: 'applied',
          applied_date: appliedDate
        },
        { headers: { 'Authorization': `Bearer ${authToken}` } }
      );

      // Notify parent to refresh dashboard
      if (onStatusUpdate) {
        onStatusUpdate();
      }

      onClose();
    } catch (error) {
      console.error('Error updating application status:', error);
      alert('Failed to update status. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNotYet = () => {
    // Just close the modal, no status update needed
    onClose();
  };

  const handleRemindLater = () => {
    // Close modal without taking action - banner will remind them later
    onClose();
  };

  if (showDateInput) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            When did you apply to {companyName}?
          </h3>
          <input
            type="date"
            value={appliedDate}
            onChange={(e) => setAppliedDate(e.target.value)}
            max={new Date().toISOString().split('T')[0]}
            className="w-full px-3 py-2 border border-gray-300 rounded-md mb-4"
          />
          <div className="flex gap-2">
            <button
              onClick={handleConfirmApplied}
              disabled={isSubmitting}
              className="flex-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-wait"
            >
              {isSubmitting ? 'Saving...' : 'Confirm'}
            </button>
            <button
              onClick={() => setShowDateInput(false)}
              disabled={isSubmitting}
              className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">
          Did you apply to {companyName}?
        </h3>

        <div className="space-y-3">
          <button
            onClick={handleYesApplied}
            className="w-full px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
          >
            ✓ Yes, I Applied
          </button>

          <button
            onClick={handleNotYet}
            className="w-full px-6 py-3 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300 transition-colors"
          >
            Not Yet
          </button>

          <button
            onClick={handleRemindLater}
            className="w-full px-6 py-3 bg-white text-gray-600 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
          >
            Remind me later
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationTrackingModal;
